"use client"

import { useEffect, useRef } from "react"

import { metaPixel } from "@/lib/analytics/meta-pixel"

/**
 * Fires `ViewContent` once for a sales page. Render-nothing, so a server
 * component page can drop it in without becoming a client component.
 *
 * `ViewContent` is the top of the funnel Meta can build an audience from: it
 * says "this person looked at THIS offer", which a bare PageView does not.
 * The `contentId` is the offer slug on purpose — it is the one key that is
 * present and identical on the landing page, the checkout and the purchase,
 * which is what lets Meta stitch the three into one funnel.
 */
export function MetaPixelViewContent({
  contentId,
  contentName,
  value,
  currency,
}: {
  contentId: string
  contentName: string
  value?: number
  currency?: string
}) {
  const sentFor = useRef<string | null>(null)

  useEffect(() => {
    if (sentFor.current === contentId) return
    sentFor.current = contentId
    metaPixel.viewContent({ contentId, contentName, value, currency })
  }, [contentId, contentName, value, currency])

  return null
}
